import { ArithmeticOperation, GymMode } from '@suntex.fim/enums';

// eslint-disable-next-line no-magic-numbers
export type GymGameNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

/**
 * Fraction labels indexed by gym step (0-based).
 */
const FRACTIONS = [
  '1/32',
  '1/16',
  '1/8',
  '1/5',
  '1/4',
  '1/3',
  '3/8',
  '1/2',
  '5/8',
  '2/3',
  '3/4',
  '7/8',
] as const;

/**
 * Decimal labels indexed by gym step (0-based).
 */
const DECIMALS = [
  '0.05',
  '0.1',
  '0.2',
  '0.25',
  '0.3',
  '0.4',
  '0.5',
  '0.6',
  '0.7',
  '0.75',
  '0.8',
  '0.9',
] as const;

const OPERATION_VERBS = {
  [ArithmeticOperation.Addition]: 'Adding',
  [ArithmeticOperation.Subtraction]: 'Subtracting',
  [ArithmeticOperation.Multiplication]: 'Multiplying',
  [ArithmeticOperation.Division]: 'Dividing',
};

/**
 * Returns the plain game label for a gym step (e.g. `1/32`, `-1`, `5`).
 */
export function gymOperandLabel(
  mode: GymMode,
  gameNumber: GymGameNumber,
): string {
  if (mode === GymMode.Fractions) return FRACTIONS[gameNumber - 1]!;
  if (mode === GymMode.Decimals) return DECIMALS[gameNumber - 1]!;
  if (mode === GymMode.Integers) return `-${gameNumber}`;
  return gameNumber.toString();
}

/**
 * Returns the operation-qualified label for a gym step (e.g. `Adding by 1/32`).
 */
export function gymGameSubtitle(
  mode: GymMode,
  op: ArithmeticOperation,
  gameNumber: GymGameNumber,
): string {
  return `${OPERATION_VERBS[op]} by ${gymOperandLabel(mode, gameNumber)}`;
}
